import { ExclamationCircleTwoTone } from "@ant-design/icons";
import { Link } from "react-router-dom";

const LimitationReachedMessage = ({ text, visible }: {
    visible: boolean,
    text: string
}) => {
    return (
        <>
            {
                visible &&
                <span style={{ marginRight: 5, fontSize: 12 }}>
                    <ExclamationCircleTwoTone />&nbsp;
                    <span>
                        You are limited to <span style={{ fontWeight: 500 }}>{text}</span> in the current plan. <Link to="/pricing/upgrade">Upgrade your plan</Link> to get more from Microtica
                    </span>
                </span>
            }
        </>
    )
}

export default LimitationReachedMessage;